<template>
  <div class="sidebar-content">
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      background-color="#ffffff"
      text-color="#303133"
      active-text-color="#409EFF"
      :router="true"
    >
      <!-- Home -->
      <el-menu-item index="/">
        <el-icon><House /></el-icon>
        <span>Home</span>
      </el-menu-item>

      <!-- 数据概览 -->
      <el-sub-menu index="2">
        <template #title>
          <el-icon><Document /></el-icon>
          <span>数据概览</span>
        </template>
        <el-menu-item index="/overview-dashboard" @click="handleClick('overview-dashboard')">
          仪表盘
        </el-menu-item>
        <el-menu-item index="/overview-stats" @click="handleClick('overview-stats')">
          统计报表
        </el-menu-item>
        <el-menu-item index="/overview-trend" @click="handleClick('overview-trend')">
          趋势分析
        </el-menu-item>
      </el-sub-menu>

      <!-- 关键词管理 -->
      <el-sub-menu index="3">
        <template #title>
          <el-icon><ChromeFilled /></el-icon>
          <span>选词参谋</span>
        </template>
        
        <!-- 核心词汇 -->
        <el-sub-menu index="3-1">
          <template #title>
            <span>核心词汇</span>
          </template>
          <el-menu-item index="/keywords/keywordsmaster" @click="handleClick('core-overview')">
            公海词库
          </el-menu-item>
          <el-menu-item index="/keywords/mykeywords" @click="handleClick('core-overview')">
            我的词库
          </el-menu-item>
          <el-menu-item index="/keywords/word-query" @click="handleClick('word-query')">
            单词查询
          </el-menu-item>
          <el-menu-item index="/keywords/word-analysis" @click="handleClick('word-analysis')">
            单词分析
          </el-menu-item>
        </el-sub-menu>

        <!-- 平台词汇 -->
        <el-sub-menu index="3-2">
          <template #title>
            <span>平台词汇</span>
          </template>
          <el-menu-item index="/keywords/*" @click="handleClick('core-overview')">
            大盘词汇
          </el-menu-item>
          <el-menu-item index="/keywords/alibaba-benchmark" @click="handleClick('core-overview')">
            阿里国际
          </el-menu-item>
          <el-menu-item index="/keywords/word-query" @click="handleClick('word-query')">
            亚马逊
          </el-menu-item>
          <el-menu-item index="/keywords/word-analysis" @click="handleClick('word-analysis')">
            单词分析
          </el-menu-item>
        </el-sub-menu>
        
        <!-- 入店词汇 -->
        <el-sub-menu index="3-3">
          <template #title>
            <span>入店词汇</span>
          </template>
          <el-menu-item index="/topkeywords/overview" @click="handleClick('store-overview')">
            概览
          </el-menu-item>
          <el-menu-item index="/topkeywords/topkeywordsdetails" @click="handleClick('store-overview')">
            词汇详情
          </el-menu-item>
          <el-menu-item index="/singletopkeyword" @click="handleClick('store-query')">
            单词查询
          </el-menu-item>
        </el-sub-menu>
        
        <!-- 趋势词汇 -->
        <el-sub-menu index="3-4">
          <template #title>
            <span>趋势词汇</span>
          </template>
          <el-menu-item index="/trend/overview" @click="handleClick('trend-overview')">
            概览
          </el-menu-item>
          <el-menu-item index="/trend/analysis" @click="handleClick('trend-analysis')">
            趋势分析
          </el-menu-item>
          <el-menu-item index="/trend/report" @click="handleClick('trend-report')">
            趋势报告
          </el-menu-item>
        </el-sub-menu>
      </el-sub-menu>

      <!-- ==================== 关键词治理（仅 admin + manager 可见） ==================== -->
      <el-sub-menu
        v-if="canSeeKeywordsGovernance"
        index="keywords-governance"
      >
        <template #title>
          <el-icon><Management /></el-icon>
          <span>关键词治理</span>
        </template>

        <!-- 负面规则管理 -->
        <el-menu-item index="/keywords/neg-rules">
          负面规则管理
        </el-menu-item>

        <!-- 负面反馈队列 -->
        <el-menu-item index="/keywords/feedback-queue">
          负面反馈队列
        </el-menu-item>

        <!-- 交互修改 / 数据审查 -->
        <el-menu-item index="/keywords/governance-review">
          交互修改
        </el-menu-item>
      </el-sub-menu>

      <!-- 产品管理 -->
      <el-sub-menu index="4">
        <template #title>
          <el-icon><Goods /></el-icon>
          <span>产品管理</span>
        </template>
        <el-menu-item index="/products/list" @click="handleClick('product-list')">
          产品列表
        </el-menu-item>
        <el-menu-item index="/products/add" @click="handleClick('product-add')">
          添加产品
        </el-menu-item>
        <el-menu-item index="/platformcodeview" @click="handleClick('product-category')">
          分类管理
        </el-menu-item>
      </el-sub-menu>

      <!-- 市场参谋 -->
      <el-sub-menu index="5">
        <template #title>
          <el-icon><Goods /></el-icon>
          <span>市场参谋</span>
        </template>
        <el-menu-item index="/market/list" @click="handleClick('market-list')">
          价格信息
        </el-menu-item>
        <el-menu-item index="/markets/markettools" @click="handleClick('market-list')">
          调研工具
        </el-menu-item>
        <el-menu-item index="/market/list" @click="handleClick('market-list')">
          分类管理
        </el-menu-item>
      </el-sub-menu>

      <!-- 选品管理 -->
      <el-sub-menu index="6">
        <template #title>
          <el-icon><ShoppingCart /></el-icon>
          <span>选品管理</span>
        </template>
        <el-menu-item index="/orders/list" @click="handleClick('order-list')">
          订单列表
        </el-menu-item>
        <el-menu-item index="/orders/process" @click="handleClick('order-process')">
          订单处理
        </el-menu-item>
        <el-menu-item index="/orders/refund" @click="handleClick('order-refund')">
          退款售后
        </el-menu-item>
      </el-sub-menu>

      <!-- 订单管理 -->
      <el-sub-menu index="7">
        <template #title>
          <el-icon><ShoppingCart /></el-icon>
          <span>订单管理</span>
        </template>
        <el-menu-item index="/orders/list" @click="handleClick('order-list')">
          订单列表
        </el-menu-item>
        <el-menu-item index="/orders/process" @click="handleClick('order-process')">
          订单处理
        </el-menu-item>
        <el-menu-item index="/orders/refund" @click="handleClick('order-refund')">
          退款售后
        </el-menu-item>
      </el-sub-menu>

      <!-- 系统设置 -->
      <el-sub-menu index="8">
        <template #title>
          <el-icon><Setting /></el-icon>
          <span>系统设置</span>
        </template>
        <el-menu-item index="/system/config" @click="handleClick('system-config')">
          参数配置
        </el-menu-item>
        <el-menu-item index="/system/user" @click="handleClick('system-user')">
          用户权限
        </el-menu-item>
        <el-menu-item index="/system/log" @click="handleClick('system-log')">
          操作日志
        </el-menu-item>
      </el-sub-menu>

      <slot name="extra-buttons"></slot>
    </el-menu>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import {
  House,
  Document,
  Goods,
  ShoppingCart,
  Setting,
  ChromeFilled,
  Management
} from '@element-plus/icons-vue'
import { useAuthStore } from '@/stores/auth'   // 项目规范：使用 useAuthStore

const authStore = useAuthStore()

// 仅管理员 + 操盘手可见「关键词治理」
const canSeeKeywordsGovernance = computed(() => {
  const role = authStore.user?.role || authStore.currentUser?.role || ''
  return ['admin', 'manager'].includes(role)
})

const activeMenu = ref('/')

const handleClick = (key) => {
  console.log(`Sidebar 导航点击: ${key}`)
}
</script>

<style scoped>
.sidebar-content {
  height: 100%;
  background-color: #ffffff;
  border-right: 1px solid #e8e8e8;
  box-sizing: border-box;
}

.sidebar-menu {
  height: 100%;
  border-right: none;
}

:deep(.el-menu-item),
:deep(.el-sub-menu__title) {
  height: 50px;
  line-height: 50px;
  font-size: 15px;
}

:deep(.el-menu-item:hover),
:deep(.el-sub-menu__title:hover) {
  background-color: #ecf5ff !important;
}

:deep(.el-icon) {
  margin-right: 8px;
}
</style>